import { render, staticRenderFns } from "./ManagePermissions.vue?vue&type=template&id=3bd3519e"
import script from "./ManagePermissions.vue?vue&type=script&lang=js"
export * from "./ManagePermissions.vue?vue&type=script&lang=js"
import style0 from "./ManagePermissions.vue?vue&type=style&index=0&id=3bd3519e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports